import { getTextAsDom } from './getTextAsDom';
import { lruMemoize } from '../../../util/lruMemoize';
const _evaluateTextAsDom = (text, callback, parentDocument) => {
  const {
    container,
    cleanup
  } = getTextAsDom(text, parentDocument);
  if (!container) {
    return null;
  }
  try {
    return callback(container);
  } finally {
    cleanup();
  }
};

/**
 * @description Parses an HTML string into a DOM container, passes it to
 * `callback`, then cleans up. Returns the callback's result, or `null` if
 * `text` is empty. Use `getTextAsDom` instead when the same HTML needs to be
 * evaluated more than once.
 */
export const evaluateTextAsDom = lruMemoize(_evaluateTextAsDom);